/**
 * Move keyboard focus to the page <main> element on route change so screen readers
 * and keyboard users start each new page at its content, not stranded on the previous
 * page's focused element. The target element should be: <main id="main" tabIndex={-1}>.
 *
 * Skipped when the user is mid-typing in a form to avoid yanking focus.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useRouteFocus(targetId: string = 'main'): void {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const active = document.activeElement as HTMLElement | null;
    if (active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA')) {
      return;
    }

    const target = document.getElementById(targetId);
    if (!target) return;

    target.focus({ preventScroll: false });
  }, [pathname, targetId]);
}
